import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.6 15.2V7.8635C0.6678 7.534 0 6.6449 0 5.6C0 4.555 0.6678 3.666 1.6 3.3365V0.8H3.2V3.3365C4.1322 3.666 4.8 4.555 4.8 5.6C4.8 6.6449 4.1322 7.534 3.2 7.8635V15.2H1.6ZM3.2 5.6C3.2 6.0418 2.8418 6.4 2.4 6.4C1.9582 6.4 1.6 6.0418 1.6 5.6C1.6 5.1582 1.9582 4.8 2.4 4.8C2.8418 4.8 3.2 5.1582 3.2 5.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.2 15.2V12.6635C6.2678 12.334 5.6 11.4449 5.6 10.4C5.6 9.355 6.2678 8.466 7.2 8.1365V0.8H8.8V8.1365C9.7322 8.466 10.4 9.355 10.4 10.4C10.4 11.4449 9.7322 12.334 8.8 12.6635V15.2H7.2ZM8.8 10.4C8.8 10.8418 8.4418 11.2 8 11.2C7.5582 11.2 7.2 10.8418 7.2 10.4C7.2 9.9582 7.5582 9.6 8 9.6C8.4418 9.6 8.8 9.9582 8.8 10.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.8 15.2V7.8635C11.8678 7.534 11.2 6.6449 11.2 5.6C11.2 4.555 11.8678 3.666 12.8 3.3365V0.8H14.4V3.3365C15.3322 3.666 16 4.555 16 5.6C16 6.6449 15.3322 7.534 14.4 7.8635V15.2H12.8ZM14.4 5.6C14.4 6.0418 14.0418 6.4 13.6 6.4C13.1582 6.4 12.8 6.0418 12.8 5.6C12.8 5.1582 13.1582 4.8 13.6 4.8C14.0418 4.8 14.4 5.1582 14.4 5.6Z"
		})
	]
});
export default SvgFilter;
